import { render, staticRenderFns } from "./estados.vue?vue&type=template&id=c11fe152"
import script from "./estados.vue?vue&type=script&lang=js"
export * from "./estados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports